import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon, StyledIconVariants } from '../SMPIcon';

type SMPRedCardProps = StyledIconVariants & {
  css?: CSS;
  style?: React.CSSProperties;
};

export const SMPRedCardIcon = (props: SMPRedCardProps): JSX.Element => {
  return (
    <SMPIcon {...props}>
      <svg width='12' height='16' viewBox='0 0 12 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect width='12' height='16' rx='2' fill='#DA020E' />
      </svg>
    </SMPIcon>
  );
};
